import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Building2, LayoutDashboard, TrendingUp, Menu, LogOut, X } from 'lucide-react';
import Logo from './Logo';

const MobileNav = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const handleNavigate = (path) => {
    navigate(path);
    setOpen(false);
  };

  const handleLogout = () => {
    setOpen(false);
    if (onLogout) onLogout();
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className="lg:hidden"
          data-testid="mobile-menu-btn"
        >
          <Menu className="w-6 h-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0">
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="p-6 border-b border-slate-100">
            <div className="flex items-center">
              <Logo variant="full" size="h-12" />
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4 space-y-2">
            <Button
              variant="ghost"
              onClick={() => handleNavigate('/dashboard')}
              data-testid="mobile-nav-dashboard"
              className={`w-full justify-start ${isActive('/dashboard') ? 'text-rose-600 bg-rose-50' : 'text-slate-600'}`}
            >
              <LayoutDashboard className="w-5 h-5 mr-3" strokeWidth={1.5} />
              Dashboard
            </Button>
            
            <Button
              variant="ghost"
              onClick={() => handleNavigate('/properties')}
              data-testid="mobile-nav-properties"
              className={`w-full justify-start ${isActive('/properties') ? 'text-rose-600 bg-rose-50' : 'text-slate-600'}`}
            >
              <Building2 className="w-5 h-5 mr-3" strokeWidth={1.5} />
              Logements
            </Button>
            
            <Button
              variant="ghost"
              onClick={() => handleNavigate('/revenue')}
              data-testid="mobile-nav-revenue"
              className={`w-full justify-start ${isActive('/revenue') ? 'text-rose-600 bg-rose-50' : 'text-slate-600'}`}
            >
              <TrendingUp className="w-5 h-5 mr-3" strokeWidth={1.5} />
              Revenus
            </Button>
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-slate-100">
            {user && (
              <p className="text-sm text-slate-500 mb-3 px-3">
                Connecté: {user.nom}
              </p>
            )}
            <Button
              variant="ghost"
              onClick={handleLogout}
              data-testid="mobile-nav-logout"
              className="w-full justify-start text-slate-600 hover:bg-slate-100"
            >
              <LogOut className="w-5 h-5 mr-3" strokeWidth={1.5} />
              Déconnexion
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNav;
